import { Box, rem, Skeleton, Stack, Text, TextInput } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import classes from "./index.module.css";

const SKELETON_ROWS = 5;

/**
 * Uma linha esqueleto do corpo da tabela de tags, no MESMO grid das linhas
 * reais (variante sem a coluna de regra: a config da etiquetagem inteligente
 * ainda não chegou), para a troca não causar reflow.
 */
function TagsRowSkeleton() {
  return (
    <Box className={`${classes.row} ${classes.rowPlain}`}>
      {/* Cor — bolinha */}
      <Box className={classes.cellColor}>
        <Skeleton
          circle
          h={rem(18)}
          w={rem(18)}
        />
      </Box>
      {/* Nome */}
      <Skeleton
        h={rem(14)}
        radius="sm"
        className={classes.cellName}
      />
      {/* Contatos usando */}
      <Box className={classes.cellCount}>
        <Skeleton
          h={rem(14)}
          w={rem(100)}
          radius="sm"
        />
      </Box>
      {/* Ações */}
      <Box className={classes.cellActions}>
        <Skeleton
          h={rem(28)}
          w={rem(28)}
          radius="sm"
        />
      </Box>
    </Box>
  );
}

/**
 * Esqueleto APENAS das linhas (dados carregados da API). Usado dentro do
 * `<TagsTab>` no ramo `tagsQuery.isPending`, quando o texto de apoio, a busca e
 * o cabeçalho fixo da tabela já estão renderizados como elementos reais no
 * index — evitando duplicar essa "moldura".
 */
export function TagsTableRowsSkeleton() {
  return (
    <>
      {Array.from({ length: SKELETON_ROWS }).map((_, index) => (
        <TagsRowSkeleton key={index} />
      ))}
    </>
  );
}

/**
 * Esqueleto COMPLETO da aba Tags, usado como fallback de Suspense enquanto o
 * chunk lazy da aba carrega (AppRoutes). Espelha a estrutura real do
 * `<TagsTab>`: renderiza o texto de apoio, o campo de busca e o cabeçalho da
 * tabela (Cor / Nome / Contatos usando / Ações) como elementos reais e
 * estáticos, e esqueletiza somente as linhas (dados carregados da API).
 */
export function TagsTabSkeleton() {
  return (
    <Stack gap={rem(16)}>
      {/* Texto de apoio (estático). */}
      <Box>
        <Text
          fz={rem(13)}
          c="dimmed">
          Taxonomia deste WhatsApp, usada em contatos e conversas. Crie novas
          tags, edite nome e cor e organize tudo por aqui. A exclusão é restrita
          ao administrador.
        </Text>
      </Box>

      {/* Busca — sempre vazia no load; renderizada como elemento real. */}
      <TextInput
        placeholder="Pesquisar tag por nome..."
        leftSection={<IconSearch size={14} />}
        size="sm"
        radius="md"
        maw={rem(320)}
        disabled
      />

      {/* Tabela: cabeçalho fixo (real) + linhas esqueletizadas. */}
      <Box className={classes.table}>
        <Box className={`${classes.header} ${classes.rowPlain}`}>
          <Text
            fz={rem(12)}
            fw={700}
            c="dimmed"
            tt="uppercase"
            className={classes.cellColor}>
            Cor
          </Text>
          <Text
            fz={rem(12)}
            fw={700}
            c="dimmed"
            tt="uppercase"
            className={classes.cellName}>
            Nome
          </Text>
          <Text
            fz={rem(12)}
            fw={700}
            c="dimmed"
            tt="uppercase"
            className={classes.cellCount}>
            Contatos usando
          </Text>
          <Text
            fz={rem(12)}
            fw={700}
            c="dimmed"
            tt="uppercase"
            className={classes.cellActions}>
            Ações
          </Text>
        </Box>

        <TagsTableRowsSkeleton />
      </Box>
    </Stack>
  );
}

export default TagsTabSkeleton;
